<template>
  <v-dialog v-model="dialog" persistent max-width="800">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined color="success" class="ml-3">
        Novo Processo de Pagamento
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title">Novo processo de pagamento</slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-alert
          type="error"
          v-if="!reports.length > 0 && !administrativeReports.length > 0"
        >
          <v-row>
            <v-col
              >Não exitem relatórios para criar um processo de pagamento</v-col
            >
          </v-row>
        </v-alert>

        <v-row>
          <v-col>
            <v-text-field
              label="Número do relatório"
              name="numero"
              type="number"
              required
              v-model="payload.numero"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              label="Total de relatórios"
              name="total"
              type="number"
              required
              v-model="payload.total"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field
              label="Código da Contratação"
              name="codigocontratacao"
              type="text"
              required
              v-model="payload.codigoContratacao"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field
              label="Período de Realização (dd/mm/yyyy - dd/mm/yyyy)"
              name="realizacao"
              type="text"
              v-mask="'##/##/#### - ##/##/####'"
              required
              v-model="payload.periodoRealizacao"
            ></v-text-field>
          </v-col>
        </v-row>

        <!-- Remoção a pedido do everton em 03/05/21 -->
        <!-- <v-row>
          <v-col>
            <v-file-input
              multiple
              label="Selecione Arquivos de Anexo"
              v-model="payload.arquivosEnviados"
              @change="loadFiles()"
            >
            </v-file-input>
          </v-col>
        </v-row> -->

        <!-- <v-row>
          <v-col>
            <h2>Arquivos anexados no processo de pagamento</h2>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-data-table
              :headers="headersFiles"
              :items="payload.arquivos"
              item-key="name"
              class="elevation-1"
              hide-default-footer
              disable-pagination
            >
              <template v-slot:item="props">
                <tr>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.type }}</td>
                  <td>
                    <v-btn
                      color="error"
                      class="mr-3"
                      @click="removeFile(props.item)"
                    >
                      <v-icon>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
              <template slot="no-data">
                <span>
                  Nenhum arquivo anexado
                </span>
              </template>
            </v-data-table>
          </v-col>
        </v-row> -->

        <v-row>
          <v-col>
            <h2>Execução do trabalho: {{ payload.horas }} h</h2>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <h2>
              Relatórios disponíveis para abertura de processo de pagamento
            </h2>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-data-table
              :headers="headers"
              :items="reports"
              v-model="selectedPayments"
              item-key="relatorioId"
              class="elevation-1"
              hide-default-footer
              disable-pagination
              :show-select="true"
            >
              <template slot="no-data">
                <span> Nenhum relatório retornado </span>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <h2>
              Relatórios administrativos disponíveis para abertura de processo
              de pagamento
            </h2>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-data-table
              :headers="headersAdministrativeReport"
              :items="administrativeReports"
              v-model="selectedAdministrativePayments"
              item-key="relatorioAdministrativoId"
              class="elevation-1"
              hide-default-footer
              disable-pagination
              :show-select="true"
            >
              <template slot="no-data">
                <span> Nenhum relatório administrativo retornado </span>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="dialog = false"
          >Fechar</v-btn
        >
        <v-btn color="info" outlined text @click="createPaymentProcess()"
          >Confirmar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { reportAPI } from "@/modules/report";
import { administrativeReportAPI } from "@/modules/administrative-report";
import { mapActions, mapGetters } from "vuex";
import { paymentReportManagementAPI } from "@/modules/payment-management";

export default {
  name: "AppModalInsertPayment",
  props: {
    dialog: { type: Boolean },
  },
  data() {
    return {
      reports: [],
      headers: [
        {
          text: "#",
          value: "relatorioId",
        },
        {
          text: "Título",
          value: "titulo",
        },
        {
          text: "Município",
          value: "municipio.nome",
        },
        {
          text: "Criador",
          value: "usuario.nome",
        },
        {
          text: "Horas",
          value: "horasTarefas",
        },
      ],
      selectedPayments: [],
      payload: {
        relatorios: [],
        arquivos: [],
        arquivosEnviados: [],
        horas: 0,
      },
      headersFiles: [
        {
          text: "Nome",
          value: "name",
        },
        {
          text: "Formato",
          value: "type",
        },
        {
          text: "Ações",
        },
      ],
      headersAdministrativeReport: [
        {
          text: "#",
          value: "relatorioAdministrativoId",
        },
        {
          text: "Título",
          value: "titulo",
        },
        {
          text: "Município",
          value: "municipio.nome",
        },
        {
          text: "Criador",
          value: "usuario.nome",
        },
        {
          text: "Horas",
          value: "horas",
        },
      ],
      administrativeReports: [],
      selectedAdministrativePayments: [],
    };
  },
  computed: {
    ...mapGetters(["isGov"]),
  },
  mounted() {
    if (this.isGov) {
      this.headersAdministrativeReport = [
        {
          text: "#",
          value: "relatorioAdministrativoId",
        },
        {
          text: "Título",
          value: "titulo",
        },
        {
          text: "Projeto",
          value: "municipio.nome",
        },
        {
          text: "Criador",
          value: "usuario.nome",
        },
        {
          text: "Horas",
          value: "horas",
        },
      ];

      this.headers = [
        {
          text: "#",
          value: "relatorioId",
        },
        {
          text: "Título",
          value: "titulo",
        },
        {
          text: "Projeto",
          value: "municipio.nome",
        },
        {
          text: "Criador",
          value: "usuario.nome",
        },
        {
          text: "Horas",
          value: "horasTarefas",
        },
      ];
    }
  },
  created() {
    this.getReports();
    this.getAdministrativeReports();
  },
  methods: {
    ...mapActions(["setLoading"]),
    getReports() {
      this.setLoading(true);

      reportAPI
        .getByUser(this.$route.params.id)
        .then((resp) => {
          this.reports = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter relatórios");
        });
    },
    createPaymentProcess() {
      if (
        this.selectedPayments.length === 0 &&
        this.selectedAdministrativePayments.length === 0
      ) {
        this.$notification.error(
          "Não é possível abrir um processo de pagamento sem relatórios!"
        );
      } else if (!this.payload.codigoContratacao) {
        this.$notification.error(
          "Não é possível abrir um processo de pagamento sem código de contratação!"
        );
      } else if (!this.payload.periodoRealizacao) {
        this.$notification.error(
          "Não é possível abrir um processo de pagamento sem período de realização!"
        );
      } else if (!this.payload.numero) {
        this.$notification.error(
          "Não é possível abrir um processo de pagamento sem colocar o número do relatório!"
        );
      } else if (!this.payload.total) {
        this.$notification.error(
          "Não é possível abrir um processo de pagamento sem o total de relatórios!"
        );
      } else {
        this.setLoading(true);

        let formData = new FormData();

        if (this.payload.arquivos.length > 0) {
          for (let i = 0; i < this.payload.arquivos.length; i++) {
            formData.append("arquivos", this.payload.arquivos[i]);
          }
        }

        formData.append(
          "relatoriosString",
          JSON.stringify(this.selectedPayments)
        );
        formData.append(
          "relatoriosAdministrativosString",
          JSON.stringify(this.selectedAdministrativePayments)
        );
        formData.append("codigoContratacao", this.payload.codigoContratacao);
        formData.append("periodoRealizacao", this.payload.periodoRealizacao);
        formData.append("horas", this.payload.horas);
        formData.append("numero", this.payload.numero);
        formData.append("total", this.payload.total);

        paymentReportManagementAPI
          .create(formData)
          .then((resp) => {
            this.setLoading(false);
            this.dialog = false;
            this.payload = {};
            this.payload.relatorios = [];
            this.payload.arquivos = [];
            this.payload.arquivosEnviados = [];
            this.$emit("onAddPayment");
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error("Erro ao inserir processo de pagamento");
          });
      }
    },
    loadFiles() {
      if (this.payload.arquivosEnviados.length > 0) {
        this.payload.arquivosEnviados.forEach((arquivo) => {
          this.payload.arquivos.push(arquivo);
        });
      }
    },
    removeFile(file) {
      this.payload.arquivos = this.payload.arquivos.filter(
        (item) => item !== file
      );
    },
    getAdministrativeReports() {
      this.setLoading(true);

      administrativeReportAPI
        .getByUser(this.$route.params.id)
        .then((resp) => {
          this.administrativeReports = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter relatórios administrativos");
        });
    },
  },
  watch: {
    selectedPayments: function (newValue) {
      this.payload.horas = 0;
      newValue.forEach((relatorio) => {
        this.payload.horas += relatorio.horasTarefas;
      });
      this.selectedAdministrativePayments.forEach((relatorio) => {
        this.payload.horas += relatorio.horas;
      });
    },
    selectedAdministrativePayments: function (newValue) {
      this.payload.horas = 0;
      newValue.forEach((relatorio) => {
        this.payload.horas += relatorio.horas;
      });
      this.selectedPayments.forEach((relatorio) => {
        this.payload.horas += relatorio.horasTarefas;
      });
    },
  },
};
</script>
